import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { FallbackImage } from "@/components/common/FallbackImage";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveProfileTooltipWrapper from "@/components/utils/tooltip/WaveProfileTooltipWrapper";
export default function DropListItemContentWaveMention(t0) {
  const $ = _c(15);
  const {
    wave
  } = t0;
  const wavePicture = wave.wave?.picture ?? null;
  const t1 = wave.wave ?? null;
  const t2 = `/waves?wave=${wave.wave_id}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>#</span>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== wave.wave_name_in_content || $[2] !== wavePicture) {
    t4 = wavePicture && <span className="tw-inline-flex tw-h-3 tw-w-3 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-full tw-leading-none"><FallbackImage primarySrc={getScaledImageUri(wavePicture, ImageScale.W_AUTO_H_50)} fallbackSrc={wavePicture} alt={`Wave ${wave.wave_name_in_content} avatar`} width={12} height={12} sizes="12px" className="tw-h-3 tw-w-3 tw-rounded-full tw-object-cover" /></span>;
    $[1] = wave.wave_name_in_content;
    $[2] = wavePicture;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== wave.wave_name_in_content) {
    t5 = <span>{wave.wave_name_in_content}</span>;
    $[4] = wave.wave_name_in_content;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = <Link onClick={_temp} href={t2} className="tw-inline-flex tw-items-center tw-gap-1 tw-align-middle tw-font-medium tw-text-primary-400 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300 desktop-hover:hover:tw-underline">{t3}{t4}{t5}</Link>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t6 || $[12] !== wave.wave_id || $[13] !== wave.wave_name_in_content) {
    t7 = <WaveProfileTooltipWrapper waveId={wave.wave_id} initialWave={t1} fallbackName={wave.wave_name_in_content}>{t6}</WaveProfileTooltipWrapper>;
    $[10] = t1;
    $[11] = t6;
    $[12] = wave.wave_id;
    $[13] = wave.wave_name_in_content;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp(e) {
  return e.stopPropagation();
}